module.exports = __webpack_public_path__ + "static/media/wordmark.0472abb0.svg";